import React, { useState, useEffect, useCallback } from 'react';
import cn from 'classnames';
import CustomDropDown from 'components/CustomDropDown'
import styles from './Layout.module.scss';
import ParkingBlock from './ParkingBlock';
import LayoutStyles from './ChargerList.module.scss';

import { useSelector } from "react-redux";
import { getSiteList } from '../../redux/siteSlice';


export default function Lll(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1]
  const siteListData = useSelector(getSiteList);
  const [siteMultiSelect, setSiteMultiSelect] = useState(siteListData);
  // const onSelect = (selectedList, selectedItem) => {}
  // const onRemove = (selectedList, removedItem) => {}
  const [outerSideClick, setOuterSideClick] = useState(true);
  const [outerSideClick1, setOuterSideClick1] = useState(true);
  const [selectedList, selectedItem] = useState();
  const filterData = useCallback((data) => {
    selectedItem(data)
  }, []);

  const parkingBlock = [
    [
      { "key": 0, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged", "rightName": "Moter", "leftName": "Moter" },
      { "key": 1, "leftSlot": "carParking", "leftIcon": "batteryPlugged", "leftStatus": "plugged", "rightSlot": "carParkingRight", "rightIcon": "batteryCharge", "rightStatus": "charging", "rightName": "Moter", "leftName": "Moter" },
      { "key": 3, "leftSlot": "carParking", "leftIcon": "batteryPlugged", "leftStatus": "plugged", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged", "rightName": "Bike", "leftName": "Moter" },
      { "key": 4, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryCharge", "rightStatus": "charging", "rightName": "Car", "leftName": "Moter" },
      { "key": 5, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryError", "rightStatus": "error", "rightName": "Hero honda", "leftName": "Moter" }
    ],

    [
      { "key": 6, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryError", "rightStatus": "error" },
      { "key": 7, "leftSlot": "carParking", "leftIcon": "batteryPlugged", "leftStatus": "plugged", "rightSlot": "carParkingAvailable", "rightIcon": "", "rightStatus": "Available" },
      { "key": 8, "leftSlot": "carParkingAvailable", "leftIcon": "", "leftStatus": "Available", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged" },
      { "key": 9, "leftSlot": "carParkingAvailable", "leftIcon": "", "leftStatus": "Available", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged" },
      { "key": 10, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged" }
    ],
    [
      { "key": 11, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged" },
      { "key": 12, "leftSlot": "carParkingAvailable", "leftIcon": "", "leftStatus": "Available", "rightSlot": "portError", "rightIcon": "", "rightStatus": "portError" },
      { "key": 13, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "portError", "rightIcon": "", "rightStatus": "portError" },
      { "key": 14, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "portError", "rightIcon": "", "rightStatus": "portError" },
      { "key": 15, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged" }
    ],
    [
      { "key": 11, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged" },
      { "key": 12, "leftSlot": "carParkingAvailable", "leftIcon": "", "leftStatus": "Available", "rightSlot": "portError", "rightIcon": "", "rightStatus": "portError" },
      { "key": 13, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "portError", "rightIcon": "", "rightStatus": "portError" },
      { "key": 14, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "portError", "rightIcon": "", "rightStatus": "portError" },
      { "key": 15, "leftSlot": "carParking", "leftIcon": "batteryCharge", "leftStatus": "charging", "rightSlot": "carParkingRight", "rightIcon": "batteryPlugged", "rightStatus": "plugged" }
    ],

  ];

  window.addEventListener('click', function (e) {
      if (e && e.target && document.getElementById('layoutClickbox')?.contains(e.target)) {
        setOuterSideClick(true)
      } else {
        setOuterSideClick(false)
      }
  });

  return (
    <>
      <div className={cn(styles.filter_flex, styles.filter_flex_layout)}>
        {/* <div className={cn(styles.flex3_item)}> */}
        <div className={cn(styles.filter_flex_item)}>
          <h3 className={Urls==='/myFleet'?cn(styles.filter_subtitle, styles.filter_subtitle_fleet_layout):cn(styles.filter_subtitle, styles.filter_subtitle_layout)}>
            {'Site : '}
          </h3>
        </div>
        <div className={cn(styles.filter_flex_spacer)} />
        <div id='layoutClickbox' className={cn(styles.filter_flex_item1)}>
          <div className={cn(styles.filter_dropdown_box, styles.filter_dropdown_box_layout)} />
          <CustomDropDown layoutClickCheck={outerSideClick}  dropdownData={siteMultiSelect} chargerCallback={filterData} text={'Select'} />
         
        </div>
        {/* </div> */}
        {/* <div className={cn(styles.filter_flex_spacer1)} /> */}
        <div className={cn(styles.filter_flex_item2)}>
          <img src={require('assets/ic_place.svg').default} alt="assets/ic_place.svg" className={cn(styles.filter_dropdown_ic, styles.filter_dropdown_ic_layout)} />
        </div>
        <div className={cn(styles.filter_flex_spacer2)} />
        {/* <div className={cn(styles.filter_flex_spacer8)} /> */}
        <div className={cn(styles.filter_flex_item)}>
          <h3 className={cn(styles.filter_title, styles.filter_title_layout)}>
           <span className={Urls==='/myFleet'?cn(styles.evsText2):cn(styles.evsText)}>{'Total No. Of EVSE’s: '}{parkingBlock.length}</span>
          </h3>
          {/* <h3 className={cn(styles.evseContainer)}>
            {'Total No. Of EVSE’s: '}{parkingBlock.length}
          </h3> */}
        </div>

        {/* <div className={cn(styles.search_panel_flex_spacer3)} /> */}
        <div className={cn(LayoutStyles.flex3_spacer1)} />
        <div className={cn(styles.search_panel_flex_item3)}>
          <div className={cn(styles.switch_to_layout_block, styles.switch_to_layout_block_layout)}>
            <div className={cn(styles.switch_to_layout_block_item)}>
              <div
                className={cn(styles.switch_to_layout_group, styles.switch_to_layout_group_layout)}
                onClick={() => props.navState(false)}>
                <h3 className={cn(styles.switch_to_layout_txt, styles.switch_to_layout_txt_layout)}>
                  {'Layout'}
                </h3>
              </div>
            </div>
            <div className={cn(styles.switch_to_layout_block_item)}>
              <div
                className={cn(styles.switch_to_list_group, styles.switch_to_list_group_layout)}
                onClick={() => props.navState(false)}>
                <h3 className={cn(styles.switch_to_list_txt, styles.switch_to_list_txt_layout)}>
                  {'List'}
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>

      <section className={cn(styles.parking_block, styles.parking_block_layout)}>
        <ParkingBlock parkingBlocks={parkingBlock}></ParkingBlock>
      </section>


    </>
  );
}